<template>
    <div style="background:white" class="ve-list-page">
        <div style="border-bottom:2px solid #389;padding-top:3px;background:white;display:flex;line-height:30px;height:37px">
            <div class="consume-mgt-toolbar" style="min-width:1200px;display:flex">
                <div style="width:70px;display:flex">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><div style="font-size:13px;margin-right:15px;width:50px;font-weight:600">{{ $LANG('0138', '新增') }} </div></el-link>
                </div>
                <div style=" font-size:12px;margin-left:10px;width:30px; ">{{ $LANG('0298', '字段') }}</div>
                <el-select v-model="selparam"  :placeholder="$LANG('1675', '请选择列名')"   size="small" style="width:120px;  ">
                    <span v-for="item in tabArr" :key='item.key' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="$LANG('1692', '请输入查询值')" ref="refqry" @keyup.enter.native="getTabList" v-model="txtparam" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend" size="small" style="width:90px; ">
                    <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="getTabList" style="color:#409eff"></el-button>
                </el-input> 
                <div style="font-size:12px;margin-right:4px;color:red;font-weight:600;margin-left:3px">{{ $LANG('0358', '状态') }}</div>
                <el-radio-group v-model="notAcc" size="small" @input="chkChg">
                    <el-radio-button label="ALL">{{ $LANG('0040', '所有记录') }}</el-radio-button>
                    <el-radio-button label="C">{{ $LANG('2012', '未记账') }}</el-radio-button>
                    <el-radio-button label="N">{{ $LANG('0203', '审核未记账') }}</el-radio-button>
                    <el-radio-button label="Y">{{ $LANG('0202', '审核已记账') }}</el-radio-button>
                </el-radio-group>
                <el-button :disabled="cfmBool " type="danger" @click="accRec" icon="iconfont icon-fapiaoguanli" size="mini" style="width:70px; height:32px;margin-left:10px">{{ $LANG('0390', '记账') }}</el-button>
                <el-button type="primary"   icon="iconfont icon-daochu" @click="expData" size="mini" style="margin-left:15px;height:30px;margin-top:1px">{{ $LANG('0228', '导出当前页数据') }}</el-button>
                <i class="iconfont icon-ziyuan consume-mgt-toolbar__field-icon" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link class="consume-mgt-toolbar__action" @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div> 
        </div>
        <div style="width:100%" class="ve-list-page__body">
            <div class="ve-list-page__table">
            <ve-table :columns="vueCol" 
                    :table-data="tabData" 
                    :columnHiddenOption="columnHiddenOption"
                    style="margin-top:0px; "
                    :border-around="true"
                    :border-x="true" 
                    :border-y="true" 
                    :fixed-header="true"
                    row-key-field-name="IDSEQ"
                    :row-style-option="rowStyleOption"
                    :cell-style-option="cellStyleOption"
                    :max-height="tabHeight" 
                    :virtual-scroll-option="virtualScrollOption"
                    :scroll-width="0"     
                    :footer-data="footerData"              
                    :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"                    
                    :column-width-resize-option="columnWidthResizeOption"
                    :cellSelectionOption="{enable: false,}"
                    id="consume_mgt"
                    ref="tableRef" >
 
            </ve-table>
            </div>
            <div style="margin-top:2px" class="ve-list-page__pagination">
                <ve-pagination
                    :total="dataCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    :page-size-option="pageList"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>
        </div> 
 
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin" v-dialogDrag  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确 定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 数据查看 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="addWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
                <Form ref="addForm" :model="formCol" :label-width="120"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabArr" :key="index" >
                        <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-checkbox size="medium" border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol[item.key]" style="width:100%"></el-checkbox> 
                            <el-input  size="medium" type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="formCol[item.key]"></el-input> 
                            <el-select size="medium" @change="selectChg(item.key)" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="formCol[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-select size="medium" filterable @change="empChg" v-else-if="item.key==='EMPNO' " v-model="formCol[item.key]"   style="width:100%">
                                <el-row v-for="(item ,index) in empArr " :key="index">
                                    <el-col :span="4">
                                        <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                    </el-col>
                                </el-row>
                            </el-select>
                            <el-select v-else-if="item.key==='ISTAX'" v-model="formCol[item.key]" size="medium" style="width:100%">
                                <el-option :label="$LANG('0283', '含税')" value="Y"></el-option>
                                <el-option :label="$LANG('0423', '不含税')" value="N"></el-option>
                            </el-select> 
                            <el-date-picker size="medium" type="month" @change="yrChange(formCol)" v-else-if="item.key==='YRMTH'" v-model="formCol[item.key]" clearable value-format="yyyy-MM" style="width:100%" ></el-date-picker> 
                            <el-date-picker size="medium" type="date"  v-else-if="item.edcss==='date'" v-model="formCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                            <el-input-number size="medium" controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="formCol[item.key]"></el-input-number> 
                            <el-input size="medium" :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag||(item.key=='FINVNO'&&hapBool)"  v-model="formCol[item.key]"></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> {{ $LANG('0968', '费用明细') }}【
                   <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="saveFlag"  @click="addDtl" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0095', '新增记录') }}</span></el-link>
                    】
                    <el-checkbox @change="selChange" size="small" true-label="Y" false-label="N" v-model="v_selAll" style="color:white">{{ $LANG('0263', '全选') }} </el-checkbox>
                    <el-button :disabled="saveFlag" @click="batEdit" type="primary" plain size="mini" style="height:27px;margin-top:3px;margin-left:10px;border:1px solid green">
                        <i class="iconfont icon-piliangbianji" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('0322', '批改') }}
                    </el-button>
                </div>  
                <el-table  :data="dtlData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        size="small"
                        style="overflow:auto;margin-top:1px;"
                        :min-height="300"
                        :height="dtlHeight" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getDtlKey"  
                        show-summary
                        :row-class-name="tabRowClass" 
                        :summary-method="getDtlSum"
                        :cell-class-name="cellClass"
                        ref="dtlref" 
                        highlight-current-row>
                    <el-table-column type="index" :label="$LANG('0310', '序号')" width="60" fixed></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                    
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <template slot-scope="scope">
                            <el-checkbox  v-if="item.edcss=='checkbox'" :disabled="item.key!=='SEL'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            <el-link v-else-if="item.key=='PAYIDNO'" :underline="false" @click="seeDay(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            <el-link v-else-if="item.key=='PATH'" :underline="false" @click="seeLink(scope.row[item.key])"><div style="color:#409eff;border-bottom:1px solid red ">{{scope.row[item.key]}}</div> </el-link>
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column> 
                    
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="230">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shangchuan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="upImg(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:8px;">{{ $LANG('0291', '图片') }}</span></el-link>
                            <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px; "></i>
                            <el-link :disabled="saveFlag" @click="cpRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:8px;">{{ $LANG('0143', '复制行') }}</span></el-link>
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'"  @click="dtlEdit(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('1639', '编辑') }}</span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="typeof(scope.row['PAYIDNO'])=='string'" @click="dtlDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:2px;">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
                <!-- 单据明细 -->
                <div style="background:#808695;border-left:2px solid #409eff;line-height:30px;color:white;padding-left:10px;font-size:14px"> {{ $LANG('2086', '费用摊分明细') }}  【
                    <el-select size="small" v-model="billType" style="width:180px">
                        <el-option v-for="(item,index) in tyArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                    </el-select>
                    <i class="iconfont icon-xinzeng" style="color:#fff;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                    <el-link :disabled="saveFlag" @click="addList" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0597', '关联单据') }}</span></el-link>
                    <i class="iconfont icon-fenzhijiedian" style="color:#fff;font-size:14px;margin-right:5px;margin-left:20px;"></i>
                    <el-link :disabled="saveFlag" @click="disFee" :underline="false" ><span style="font-size:12px;margin-right:5px;color:white">{{ $LANG('0608', '分摊费用') }}</span></el-link>
                    】
                </div> 
                <el-table  :data="listData" 
                        border                            
                        disabled-hover
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :height="200" 
                        :cell-style="{padding:'2px'}"
                        :row-key="getListKey"  
                        show-summary
                        :summary-method="getListSum"
                        ref="listref" 
                        class="custom-table-border"
                        highlight-current-row>
                    <el-table-column type="index" width="60" :label="$LANG('0310', '序号')" fixed ></el-table-column>
                    <span v-for="(item,index ) in listArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'  "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="75">
                        <template slot-scope="scope">
                             
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link  @click="listDel(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:12px; ">{{ $LANG('0131', '删除') }}</span></el-link>
                        </template>
                    </el-table-column>  
                </el-table>  
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <span :style="stfgColor">
                        <i class="iconfont" :class="stfgCss"  style="font-size:30px; margin-left:40px;margin-right:70px;height:35px;vertical-align:middle"></i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="saveFlag" type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dtlWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{addFlag=='create'?$LANG('0095', '新增记录'):$LANG('0921', '编辑记录')}}</span>
            </div> 
            <Form  :model="dtlCol" :label-width="120"  :rules="dtlValidate" label-position="right" inline >
                <span v-for="(item,index) in dtlArr" :key="index" >
                    <FormItem :class="item.key=='REASON'?'item-width2':'item-width'"  :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                        <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="dtlCol[item.key]" style="width:100%"></el-checkbox> 
                        <el-input resize="none"  type="textarea" :rows="2"  v-else-if="item.key==='REASON'"   v-model="dtlCol[item.key]"></el-input> 
                        <el-select filterable :disabled="saveFlag||item.disabled=='Y'" v-else-if="item.edcss==='select'" v-model="dtlCol[item.key]"   style="width:100%">
                            <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DISTY'" v-model="dtlCol[item.key]"  @change="disChg" style="width:100%">
                            <el-option v-for="(item,index) in disArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-select @focus="showFlag=true" :disabled="saveFlag" v-else-if="item.key==='ACNO'" v-model="dtlCol[item.key]"  ref="selectTree" style="width:100%">
                            <el-option  :value="dtlCol[item.key]" :label="dtlCol['ACNM']" style="height:auto" hidden />
                            <el-input   :placeholder="$LANG('1779', '请输入关键字进行过滤')" v-model="filterText" size="small"  ></el-input>
                            <el-tree :data="subData" 
                                        :props="defaultProps" 
                                        @node-click="findClick" 
                                        node-key="id"           
                                        :filter-node-method="filterNode"            
                                        :style="{background:'#fff',overflow:'auto',height:'400'}"
                                        highlight-current
                                        ref="findtree"
                                        :default-expanded-keys="expkeys"  
                                        :expand-on-click-node="false">
                                <template v-slot="{node,data}">                                     
                                    <span v-if="data.id ==0 "   >                    
                                        <span  style="color:#F56C6C;font-size:14px;"><i class="iconfont icon-fenlei" style="color:#F56C6C;font-size:18px;"></i> {{ node.label}} </span>
                                    </span>                  
                                    <span v-else > 
                                        <span style="color:#rgb(45, 45, 46);font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;"></i> {{ node.label}} </span>
                                    </span>
                                </template>
                            </el-tree> 
                        </el-select>
                        <el-select :disabled="saveFlag" v-else-if="item.key==='DEPTNO'" v-model="dtlCol[item.key]"  @change="deptChg" style="width:100%">
                            <el-option v-for="(item,index) in deptArr " :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                        </el-select>
                        <el-input clearable @clear="clrBtn" :disabled="saveFlag" @focus="inputBtn(item.key)" v-else-if="item.edcss=='button'"   v-model="dtlCol[item.key]" style="width:100%;border:1px solid #808695"> </el-input>
                        <el-date-picker type="date"  v-else-if="item.edcss==='date'" v-model="dtlCol[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                        <el-input-number controls-position="right" v-else-if="item.edcss==='number'"  style="width:100%" v-model="dtlCol[item.key]"></el-input-number> 
                        <el-input :placeholder="item.holder" type="text" v-else  :disabled="item.disabled==='Y'?true:false||saveFlag"  v-model="dtlCol[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="dtlWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="dtlSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用单据-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="refWin" v-if="refWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0732', '分摊关联单据明细') }}</span>
            </div> 
            <div style="border-bottom:2px solid #389;margin-top:-2px;background:white; ">
                <el-checkbox border size="small"  @change="selChg"  v-model="selAll" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <el-select v-model="selparam3"  :placeholder="$LANG('1675', '请选择列名')" clearable size="small" style="width:130px;margin-left:15px; ">
                    <span v-for="item in refArr" :key='item.key'>
                        <el-option v-if="item.thide=='N'" :label="item.title" :value="item.key"></el-option>
                    </span>
                </el-select>
                
                <el-input :placeholder="$LANG('1692', '请输入查询值')" ref="refqry" v-model="textparam3" size="small" style="width:340px;height:30px; ">
                    <el-select v-model="oper3"  size="small" slot="prepend" style="width:110px;  ">
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="qryRefData" style="color:#409eff"></el-button>
                </el-input>  
                <el-button @click="cfmSave" style="margin-left:15px" icon="iconfont icon-chenggong1" type="primary" size="mini">{{ $LANG('0893', '确定选择') }}</el-button>
            </div>
            <div style="height:89vh;overflow-y:auto">
                <el-table  :data="refData" 
                        border                            
                        disabled-hover
                        :cell-style="{padding:'2px'}"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :min-height="200" 
                        class="custom-table-border"
                        :row-key="getRefKey"  
                        v-loading="v_loading"
                        :element-loading-text="$LANG('1959', '加载中')"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        ref="refjoin" 
                        highlight-current-row>
                    <el-table-column type="index" width="60" :label="$LANG('0310', '序号')" fixed ></el-table-column>
                    <span v-for="(item,index ) in refArr" :key="index">
                        <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column>
                        <el-table-column  v-if="item.edcss=='checkbox' "
                            :prop="item.key"
                            :label="item.title"
                            :align="item.align"                                  
                            width="80">
                            <template slot-scope="scope">
                                <el-checkbox  true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                            </template>
                        </el-table-column> 
                    </span>
                </el-table>
            </div>
        </el-dialog>
        <!-- 上传图片-->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="imgWin" width="1200" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0513', '上传图片') }}</span>
            </div> 
            <div class="one-div" style="height:28px">
                <span  class="oneRow">最多上传6张图片(可以是图片格式或PDF格式）</span>
 
            </div>
            <div style="display:flex;margin-left:30px;height:440px;flex-wrap:wrap;overflow-y:auto"  >
                <Upload
                    ref="upload"
                    name="upfile"
                    :data="uploadData"
                    :show-upload-list="false"
                    :before-upload="beforeImgFile"
                    :on-success="successImgFile"
                    :on-progress="handleProgress"
                    :with-credentials="true"                            
                    :max-size="10240"
                    :on-exceeded-size="handleMaxSize"
                    :format="['jpg','jpeg','png','gif','bmp','tiff','pdf' ]"
                    :on-format-error="handleFormatError"
                    type="drag"
                    :action="uploadUrl" 
                    style="display: inline-block;width:150px; ">                           
                    <div style="padding: 1px 0;width:150px;height:130px;" >
                        <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                        <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                    </div>                                                     
                </Upload> 
                <div style="display:flex;margin-left:30px;height:440px;flex-wrap:wrap"  >
                    <div v-if="FILEPATH" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH &&FILEPATH.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div>
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH]" style="width:200px;height:150px;" :src="FILEPATH">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <!-- <i class="el-icon-picture-outline" style="font-size:100px"></i> -->
                                <span style="color:red;font-weight:700;font-size:14px">显示错误</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(0)"><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH2" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;"> 
                        <div v-if="FILEPATH2 &&FILEPATH2.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH2" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH2]" style="width:200px;height:150px;" :src="FILEPATH2">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(1) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH2)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH3" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH3 &&FILEPATH3.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH3" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH3]" style="width:200px;height:150px;" :src="FILEPATH3">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(2) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH3)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH4" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH4 &&FILEPATH4.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH4" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH4]" style="width:200px;height:150px;" :src="FILEPATH4">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(3) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH4)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH5" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH5 &&FILEPATH5.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH5" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH5]" style="width:200px;height:150px;" :src="FILEPATH5">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(4) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH5)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                    <div v-if="FILEPATH6" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px;">  
                        <div v-if="FILEPATH6 &&FILEPATH6.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                            <iframe :src="FILEPATH6" frameborder="0" style="width: 100%; height: 100%"></iframe>
                        </div> 
                        <el-image v-else fit="fill" :preview-src-list="[FILEPATH6]" style="width:200px;height:150px;" :src="FILEPATH6">
                            <div slot="error" class="image-slot" style="margin:30px 50px;">
                                <span style="color:red;font-weight:700;font-size:14px">图片未上传</span>
                            </div>
                        </el-image>
                        <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                            <el-link :disabled="saveFlag" :underline="false" @click="imgDel(5) "><Icon type="md-close" /> 删除</el-link>
                            <el-link :underline="false" @click="imgPreview( FILEPATH6)"><Icon type="ios-search" /> 预览</el-link>
                        </div>
                    </div>
                </div> 
            </div> 
            
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showViewer" width="800px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <el-image fit="scale-down" :preview-src-list="[listurl]" style=" margin:5px auto;height:500px;width:100% " :src="listurl"></el-image>
        </el-dialog>
        <!-- 链接图片预览 -->
        <el-dialog v-dialogDrag :visible.sync="linkWin" width="1200px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0141', '预览') }}</span>
            </div>
            <div style="display:flex;width:1150px;flex-wrap:wrap">
                <div v-for="(item,index) in linkArr" :key="index" style="border:1px solid #ccc;height:183px ;width:200px;margin-right:30px; ">    
                    <div v-if="item &&item.lastIndexOf('.pdf')>-1" style="width:200px;height:153px;border:1px solid #e8eaec;overflow-y:hidden">
                        <iframe :src="item" frameborder="0" style="width: 100%; height: 100%"></iframe>
                    </div>
                    <el-image v-else fit="fill" :preview-src-list="[item]" style="width:200px;height:150px;" :src="item"></el-image>
                    <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                        <el-link   :underline="false" @click="downFile(item) "><i class="iconfont icon-xiazai" style="font-size:12px"> {{ $LANG('0129', '下载') }}</i> </el-link>
                        <el-link :underline="false" @click="imgPreview( item)"><i class="iconfont icon-chakan1" style="font-size:12px"> {{ $LANG('0141', '预览') }}</i></el-link>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 分摊费用 -->
        <el-dialog v-dialogDrag :visible.sync="disWin" width="450px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0607', '分摊方式') }}</span>
            </div>
            <div style="display:flex">
                <div style="width:100px;line-height:30px">{{ $LANG('0607', '分摊方式') }}</div>
                <el-select size="middle" v-model="feeMth" style="width:280px">
                    <el-option v-for="(item,index) in feeArr" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                </el-select>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="disWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="feeSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 记账 -->
        <el-dialog v-dialogDrag :visible.sync="accWin" width="1220px" append-to-body :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1337', '选择记账费用') }}</span>
            </div>
            <div style="height:30px;line-height:30px;background:#f1f2f3;color:red;border-left:3px solid #389;padding-left:5px">
                 {{ $LANG('2087', '提示：当费用记录已记账后，则不再显示') }}
            </div>
            <div style="height:30px;line-height:30px;background:#fff; ">
                <el-checkbox border size="small"  @change="chkSel"  v-model="v_all" true-label="Y"  false-label="N"><span style="font-size:12px;margin-left:5px;color:#389">{{ $LANG('0263', '全选') }}</span></el-checkbox>
            </div>
            <div style="display:flex;overflow-y:auto;max-height:88vh;width:100%">
                <div v-if="stepFlag">
                    <el-table  :data="bankData" 
                            border                            
                            disabled-hover
                            :cell-style="{padding:'2px'}"
                            style="overflow:auto;margin-top:1px; width:1200px"
                            size="small"
                            :height="300" 
                            :row-key="getDtlKey"  
                            class="custom-table-border"
                            show-summary
                            :summary-method="getSummary"
                            ref="bankref" 
                            highlight-current-row>
                        <el-table-column type="index" :label="$LANG('0310', '序号')" width="60" fixed></el-table-column>
                        <span v-for="(item,index ) in dtlArr" :key="index">
                            <el-table-column  v-if="item.thide==='N' &&item.edcss!=='checkbox' "
                                :prop="item.key"
                                :label="item.title"
                                show-overflow-tooltip
                                :align="item.align"                                  
                                :sortable="item.sortable=='N'"
                                :min-width="item.width">
                            </el-table-column> 
                            <el-table-column  v-if="item.edcss=='checkbox'||item.key=='SEL' "
                                :prop="item.key"
                                :label="item.title"
                                :align="item.align"                                  
                                width="80">
                                <template slot-scope="scope">
                                    <el-checkbox  :disabled="item.key!=='SEL'" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                </template>
                            </el-table-column>
                        </span>
                    </el-table>  
                </div>
                <span v-if="!stepFlag">
                    <bank-day ref="refbank" @child-save="finSave" @child-exit="finExit"></bank-day>
                </span>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="accWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-xiayiyehouyiye"  @click="nextStep" style="margin-right:10px;">{{ $LANG('0422', '下一步') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 明细表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :visible.sync="dayWin" :width="dlgWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1106', '日记账明细') }} </span>
            </div> 
            <div style="height:85vh;overflow-y:auto" >
                <tmpl-bank ref="refday"></tmpl-bank>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="dlgWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 分摊费用 -->
        <el-dialog v-dialogDrag :visible.sync="batWin" width="450px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0048', '批改明细') }}</span>
            </div>
            <div style="display:flex">
                <div style="width:100px;line-height:30px">{{ $LANG('0558', '付款期限') }}</div>
                <el-select size="middle" v-model="v_time" style="width:280px" clearable>
                    <el-option v-for="(item,index) in timeArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                </el-select>
            </div>
            <div style="display:flex;margin-top:15px">
                <div style="width:100px;line-height:30px">{{ $LANG('0560', '付款类别') }}</div>
                <el-select size="middle" v-model="v_cate" style="width:280px" clearable >
                    <el-option v-for="(item,index) in payArr" :key="index" :label="item.CNAME" :value="item.CNAME"></el-option>
                </el-select>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="batWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="batSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 修改发票号码 -->
        <el-dialog v-dialogDrag :visible.sync="invWin" width="400px" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0258', '修改') }}</span>
            </div>
            <div style="display:flex">
                <div style="width:100px;line-height:30px">{{ $LANG('0635', '发票号码') }}</div>
                <el-input type="text" v-model="v_invno"></el-input>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="invWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="invSave" style="margin-right:10px;">{{ $LANG('1638', '确定') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_cond="t_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog> 
        <!-- 加载-->
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>  
</template>
<script>
import pubWin from '../datamgt/pubwin.vue'
import bankDay from './inv_bankday.vue' 
import tmplBank from './tmpl_bankday.vue'
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate, getDate2,getLastDay} from '../../api/Select' 
import FileSaver from 'file-saver'
import repWin from '../datamgt/repWin.vue' 
import { startWorkflowInstance } from '@/utils/workflowDesigner.js'
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition } from '@/utils/veTableHeaderQuery'
//局部注册
export default {
    name:"consume_manage",
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '227450',
            fieldIdseq: '227450',
            fieldLstseq: '2',
            scopeRefItmseq: '900011',
            mainColumnKey: 'tabArr',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'tableRef',
            lockedFieldKeys: ['SEL'],
            syncMainColumnSettings: true,
            generatedFixedColumnKeys: ['rownum', 'oper'],
        })
    ],
    data () {
        return {
            expkeys:['0'],
            loadWin:false,
            t_cond:'',
            saleCol:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            v_invno:'',
            invWin:false,
            v_time:'',
            v_cate:'',
            dataCount:0,
            pageSize:50,
            v_all:'N',
            v_selAll:'N',
            v_rowRec:{},
            pageList: [50,500,1000],  
            allList:[],
            stepFlag:true,
            dayWin:false,
            feeMth:'',
            linkWin:false,
            bankData:[],
            feeArr:[],
            disWin:false,
            FILEPATH:'',
            FILEPATH2:'',
            FILEPATH3:'',
            FILEPATH4:'',
            FILEPATH5:'',
            FILEPATH6:'',
            d_stfg:false,
            v_idseq:'',
      
            notAcc:'C',
            filterText:'',
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
            videoUploadPercent:0,
            videoFlag:false,
            uploadData:{}, //上传数据
            imgWin:false,
            selAll:'N',
            refData:[],
            refWin:false,
            billType:'',
            dtlWin:false,
            dtlCol:{},
            v_loading:false,
            addWin:false,
            operArr:[],
            addFlag:'create',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            stfgCss:'',
            stfgColor:'',
            oper:'like',
            batWin:false,
            selparam:'DTTM',
            oper3:'like',
            selparam3:'IDNO',
            textparam3:'',
            disabled:false, //新增权限制
            txtparam:'',
            idseq:'', //菜单主键
            lstseq:'',//菜单主键
            formCol: {},
            tabData:[], //表数据
            tabArr:[], //表列
            dtlArr:[],
            dtlData:[],
            listArr:[],
            listData:[],
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getTableRecMany' , 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
 
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            comboArr:[],
            notNull:[],
            notDtl:[],
            delArr:[],
            showFlag:true,
            ruleValidate:{},
            dtlValidate:{},
            dtlFlag:'create',
            rowIndex:'',
            empArr:[],
            v_stfg:'',
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            othBool:false, //仅看自己 ,为true时--禁止
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            deptArr:[],
            disArr:[],
            tyArr:[],
            refArr:[],
            v_view:'',
 
            v_type:'',
            delData:[],
 
            listurl:'',
            showViewer:false,
            accWin:false,
            linkArr:[],
            repDlg:false,
            v_idno:'',
            hapBool:false,
            v_replist:[],
            repArr:[],
            repWin:false,
            repUrl:'',
            v_commit:true,
            v_data:[],
            v_row:{},
            queryRequestId:0,
            vueCol:[],
            initCol:[],
            pageIndex:1,
            v_invRow:{},
            loadingInstance: null,
            columnHiddenOption: {
                // default hidden column keys
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: {
                clickHighlight: true,                
            }, 
            startRowIndex: 0,
            footerData:[], 
            cellStyleOption: {
                bodyCellClass: ({ row, column, rowIndex }) => {
                    return "table-body-cell-class1"      
                },
                headerCellClass: ({column, rowIndex }) => {
                    if (column.field=='#'){
                        return "table-head-cell-class2"
                    }else{
                        return "table-head-cell-class" 
                    }
                },
                footerCellClass: ({ row, column, rowIndex }) => {
                    return "table-foot-cell-class";
                },
            },
            virtualScrollOption: { enable: false },
            v_inputrow:{},
            v_sort:'asc',
            payArr:[],
            timeArr:[],
            appWin:false,
            appRow:{},
            subData:[],
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                label: 'label'
            },
        }
    },
    mounted () { 
        this.getData()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','227450','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //用户表单新增、编辑、审核、下推权限  
        getBaseData(this.v_url,'userno',this.v_username ,'frmidseq','227450','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (res.result.length>0){
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //下推
                    this.cancelBool=true
                }if (row.ISOTH=='Y'){ //仅看自己的记录
                    this.othBool=true
                }
                //查询数据
                this.chkChg(this.notAcc)
            }
        })  
        //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','LSTSEQ','2','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notDtl = res.result
            res.result.forEach(item => {
                let v_fldnm =this.$translate.getColTitle(item, this.$store.state.lang)
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空')}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.dtlValidate =ruleObj
        })
        //操作符
        getBaseData(this.v_formurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.empArr =res.result
        })
        getBaseData(this.v_formurl,'corpid',this.v_corpid,'','','hr_frame','').then(res=>{
            this.deptArr =res.result
        })
 
        getBaseData(this.v_formurl,'PARENTNO','228806','','','v_sys_base','').then(res=>{
            this.disArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','230797','','','v_sys_base','').then(res=>{
            this.feeArr =res.result
        })
        getBaseData(this.v_formurl,'PARENTNO','228812','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        })
        this.comSelect()
        //付款期限
        getBaseData(this.v_formurl,'PARENTNO','15562','','','v_sys_base','').then(res=>{
            this.timeArr =res.result
        })
        //付款类别
        getBaseData(this.v_formurl,'PARENTNO','227453','','','v_sys_base','').then(res=>{
            this.payArr =res.result
        })
        
    },
    computed: {
        dlgWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 675) + 'px';
        },
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    components: {
        bankDay,
        tmplBank,
        repWin,
        pubWin,
        VeColumnConfigDialog,
    },
    destroyed() {
        this.loadingInstance.destroy()
    },
    created () {       
        if (this.v_username){ 
            this.loadingInstance = this.$veLoading({
                target: document.querySelector("#consume_mgt"),
                name: "wave",
            })
            
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.findtree[0].filter(val);
        } 
    },
    methods: {
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        yrChange(row){
            let v_day =0
            if (row['DAYS'] && Number(row['DAYS'])>0){
                v_day =Number(row['DAYS'])
            }
            let v_dttm =getLastDay(row['YRMTH'],v_day)
            this.$set(this.formCol,'PAYDTTM',v_dttm)
        },
        // 获取 树形控件数据
        getData() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_SUBJECT_MENU',p_cond:' and ( corpid=\''+this.v_corpid+'\') ORDER BY code'}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.subData =res.result;  
                    // vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                    //     vm.$refs.eltree.setCurrentKey(vm.treeid)
                    // })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }  
                
            })                            
        },
        //节点点击
        findClick(data ){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_table:'V_SUBJECT_MENU',p_key: 'parentno',p_value:data.id},
            }).then(res=>{
                if (res.result.length==0 && data.id !=='0'){
                    var that =this
                    //console.log(data.id,data.label,data.icon)
                    Object.assign(this.dtlCol,{ACNM: data.label,ACNO:data.id})
                    that.$forceUpdate()
                    this.showFlag =false
                    this.filterText =''
                    that.$refs['selectTree'][0].blur()   
                }
            })
        },
        //复制行记录
        cpRec(row,index){
            let v_obj ={DEPTNM:row['DEPTNM'],DEPTNO:row['DEPTNO'],REFIDTY:row['REFIDTY'],REFIDNO:row['REFIDNO'],ACNO:row['ACNO'],
                        ACNM:row['ACNN'],CRCY:row['CRCY'],REASON:row['REASON'], PAYMTH:row['PAYMTH'],CHKAMT:'', PAYTIME:row['PAYTIME'],PAYTYPE:row['PAYTYPE'],
                        RMK:row['RMK'],REFORDNO:row['REFORDNO'] ,REFMATNO:row['REFMATNO'],ISCP:'Y',LSTSEQ:'',REFMATNM:row['REFMATNM']
                        }
            this.dtlData.splice(index+1,0,v_obj)  //在其下方插入一行
        },
        expData(){
            this.loadWin =true   
            //导出
            this.$axios({
                method: 'post',
                url:'xuper_auth/report/GenExcel',
                data: {p_idseq:'227450',p_lstseq:'2',p_json:JSON.stringify(this.tabData),p_action:'报销明细'},
                responseType:'blob' //关键，声明响应类型为二进制流
            }).then(response=>{ 
                // 从响应头解析后端设置的文件名
                // 创建Blob对象并触发下载  创建下载链接
                const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob)
                link.download = this.$LANG('0066', '报销明细')+'_'+getDate('full')+'.xls'
                link.click()
                URL.revokeObjectURL(link.href)
                this.loadWin =false
            }) 
        },
        btnSure(obj){
             if (this.v_key =='REFORDNO'){
                Object.assign(this.dtlCol,{REFORDNO:obj['IDNO'],REFMATNO:obj['MATNO'],REFMATNM:obj['MATNM'] })
            }    
            this.btnWin =false
        },
        clrBtn(){
            Object.assign(this.dtlCol,{REFORDNO:'',REFMATNO:'',REFMATNM:'' })
            this.$forceUpdate()
        },
        inputBtn(  key){
            this.v_key =key    
            if (key=='REFORDNO'){
                this.v_table ='V_ordITM'
                this.tableCol =this.saleCol
                this.t_cond=''
                this.v_key2 ='ORDstfg'
                this.v_value2='Y'
            }
            this.btnWin =true
        },
        showApp(row){
            this.appRow =JSON.parse(JSON.stringify(row))
            this.appWin =true
            // 使用文件的IDSEQ作为业务ID查询审批数据
            const businessId = row.IDSEQ  
            this.$axios({   // 日志记录
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key: 'IDSEQ',p_value: businessId, p_table:'V_SYS_FLOW_APPLOG' },
            }).then(res=>{
                this.approvalLogs =res.result 
                // 审批用户
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key: 'IDSEQ',p_value: businessId, p_table:'sys_flow_appuser' },
                }).then(res=>{
                    this.approvalUsers =res.result
                    // 合并数据创建时间线数据
                    this.createTimelineData(row)
                })
            }).catch(err => {
                this.promptWin = true;
                this.prompt = this.$LANG('1473', '查询审批流程数据失败，请稍后重试');
            })
        },
        selChange(){
            if (this.v_selAll=='Y'){
                this.dtlData.forEach(item=>{
                    item['SEL'] ='Y'
                })
            }else{
               this.dtlData.forEach(item=>{
                    item['SEL'] ='N'
                }) 
            }
        },
        batEdit(){
            let v_bool =false
            this.dtlData.some(item=>{
                if (item['SEL']=='Y'){
                    v_bool =true
                }
            })
            if (v_bool){
                this.batWin =true
            }else{
                this.promptWin =true
                this.prompt=this.$LANG('1775', '请选择要修改的记录')
            }
        },
        batSave(){
            this.dtlData.forEach((item,index)=>{
                if (this.v_time){
                    item['PAYTIME'] =this.v_time
                }
                if (this.v_cate){
                    item['PAYTYPE'] =this.v_cate
                }
            })
            this.batWin =false
        },

        inputChg(e,column){
            this.v_inputrow[column]=e.target.value
            this.v_row[column] =e.target.value
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            } 
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]  
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]     
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
        //页号改变
        pageNumberChange(pageIndex) {
            this.pageIndex = pageIndex
            this.changePage(pageIndex)
        },
        pageSizeChange(pageSize) {
            this.pageIndex = 1
            this.pageSize = pageSize
            this.changePage(this.pageIndex)
        },
        cellClass({row,column,rowindex ,colindex}){
 
            if (column['property']=='PAYTIME') {  //未开始
                return 'bold-row';
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['ISCP'] =='Y'){
                return 'red-row';
            }
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getTabList()
        } ,

        repPreview(v_idno,v_val){
            this.repWin =true
            if (v_val=='stk'){ //以发票为主线
                this.repUrl =this.$store.state.repUrl+ 'stk_poin.cpt'+'&p_corpid='+this.v_corpid+'&p_idno='+v_idno
            }else if (v_val =='po'){ //采购单或送货单
                if (v_idno.indexOf('CGSH')>-1){
                    let v_rep = 'posend.cpt'
                    this.repUrl =this.$store.state.repUrl+ v_rep +'&p_corpid='+this.v_corpid+'&p_idno='+v_idno
                }else{
                    let v_rep =this.v_corpid=='300' ?'rep_poord2.cpt':'rep_poord.cpt'
                    this.repUrl =this.$store.state.repUrl+ v_rep +'&p_corpid='+this.v_corpid+'&p_idno='+v_idno
                }
            } 
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                if (this.v_rowRec['REFIDTY']=='STK'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'rep_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else if (this.v_rowRec['REFIDTY']=='OUT'){ //以发票为主线
                    this.repUrl =this.$store.state.repUrl+ 'out_payable.cpt'+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }else{
                    this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
                }
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
            this.v_rowRec =JSON.parse(JSON.stringify(row))
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.pageSize;
            var _end = index * this.pageSize
            this.pageIndex =index
            this.tabData = this.allList.slice(_start,_end)
            this.getFootSum()
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.pageSize){
                this.tabData = this.allList          
            }else{
                this.tabData =this.allList.slice(0,this.pageSize) //返回选定元素的子数组，不包含结尾元素            
            }
            this.getFootSum()
        },
        getFootSum(){ //TTLAMT'||column.property==='OKAMT'||column.property==='NOAMT'
            let v_ttlamt =this.tabData.reduce((prev,cur)=>{
                let v_qty =cur.TTLAMT ||0    
                return Number(prev) + Number(v_qty) 
            },0)
            // footer data
            this.footerData =[
                {
                    rowKey: 0,
                    index: this.$LANG('0280', '合计'),
                    TTLAMT: v_ttlamt?v_ttlamt.toLocaleString():'',
                },
            ]
        } ,
        downFile(item){
            let blob =new Blob([item],{type:'text/plain;charset=utf-8'})
            const arr_name=item.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(item,file_name) 
        },
        //链接详情
        seeLink(val){
            this.linkWin =true
            this.linkArr =val.split(',').filter(item=>{
                return item !==''
            })
        },
        chkChg(val){
            if (val=='N'){
                this.getFeeList(' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is null)')
            }else if (val=='Y'){
                this.getFeeList(' and idseq in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)')
            }else if (val=='C'){
                this.getFeeList(' and idseq not in (select idseq from V_FIN_FEEDTL where stfg=\'Y\' and payidno is not null)')
            }else{
                this.getTabList()
            }
        },
        seeDay(idseq){
            this.dayWin =true
            this.$nextTick(()=>{
                this.$refs['refday'].initData(idseq)
            })
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        finExit(){
            this.accWin =false
            this.stepFlag =true
        },
        finSave(idseq){
            this.accWin =false
            this.stepFlag =true
            this.getDtlData(this.v_idseq)
        },
        //记账
        accRec(){
            this.v_data=[]
            this.v_all ='N'
            this.tabData.forEach(item=>{
                if (item['SEL']=='Y'){
                    this.v_data.push(JSON.parse(JSON.stringify(item)))
                }
            })
            const v_set =[...new Set(this.v_data.map(item=>item['EMPNO']))]
            if (this.v_data.length ==0){
                this.promptWin =true
                this.prompt =this.$LANG('1782', '请选择需要记账的单据')
            }else if (v_set.length>1){
                this.promptWin =true
                this.prompt = '不能选择记账多于一个的报销用户' 
            }else{
                let v_bool =true ,v_tax =''
                this.v_data.forEach((item,index)=>{
                    if (index ==0){
                        v_tax =item['ISTAX']
                    }
                    if (v_tax !==item['ISTAX']){
                        v_bool =false
                    }
                })
                if (v_bool ){
                    this.accWin =true
                    this.bankData=[]
                    //选择记录
                    this.v_data.forEach(item=>{
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'idseq', p_value:item['IDSEQ'], p_cond: ' order by lstseq' ,p_table:'V_FIN_FEEDTL'},
                        }).then(res=>{ 
                            res.result.forEach(it=>{  
                                if (!it['PAYIDNO']){
                                    this.bankData.push(it)
                                }
                            })
                            this.$nextTick(()=>{
                                this.$refs['bankref'].doLayout()
                            })
                            
                        })
                    })
                }else{
                    this.promptWin =true
                    this.prompt =this.$LANG('1857', '存在不同的含税类型，请核查')
                }
            } 
        },
 
        //图片预览
        imgPreview(path){
            if (path &&path.lastIndexOf('.pdf')>-1){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            }else{
                this.showViewer=true
                this.listurl=path
            }
        },
        //图片删除，操作数组
        imgDel( index){
            this.$confirm('你确定要删除此图片吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (index==0){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH:''}) )
                    this.FILEPATH =''
                }else if (index==1){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH2:''}) )
                    this.FILEPATH2=''
                }else if (index==2){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH3:''}) )
                    this.FILEPATH3=''
                }else if (index==3){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH4:''}) )
                    this.FILEPATH4=''
                }else if (index==4){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH5:''}) )
                    this.FILEPATH5=''
                }else if (index==5){
                    this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH6:''}) )
                    this.FILEPATH6=''
                }
                
                               
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误')+','+file.name + ' '+this.$LANG('1431', '是不正确， 请选择图片或PDF格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' '+this.$LANG('1561', '文件太大， 不能超出')+'10M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
             
            let v_filename=this.$store.state.nasUrl+res.result 
            let v_nasPATH ='/web/web_images/material/'+res.result               
            if (!this.FILEPATH ){
                this.FILEPATH =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH:v_filename}) )             
            }else if (!this.FILEPATH2 ){
                this.FILEPATH2 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH2:v_filename}) )             
            }else if (!this.FILEPATH3 ){
                this.FILEPATH3 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH3:v_filename}) )             
            }else if (!this.FILEPATH4 ){
                this.FILEPATH4 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH4:v_filename}) )             
            }else if (!this.FILEPATH5){
                this.FILEPATH5 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH5:v_filename}) )             
            }else if (!this.FILEPATH6 ){
                this.FILEPATH6 =v_filename
                this.dtlData.splice(this.rowIndex,1,Object.assign(this.dtlCol,{IMGPATH6:v_filename}) )             
            } 
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {
            this.fileName= this.v_username+getDate('year')   
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise;
  
        },
  
        upImg(row,index){
            this.imgWin =true
            this.rowIndex =index
            this.FILEPATH =row['IMGPATH']
            this.FILEPATH2 =row['IMGPATH2']
            this.FILEPATH3 =row['IMGPATH3']
            this.FILEPATH4 =row['IMGPATH4']
            this.FILEPATH5 =row['IMGPATH5']
            this.FILEPATH6 =row['IMGPATH6']
            this.dtlCol=JSON.parse(JSON.stringify(row))
        },
        //确定选择 所关联记录
        cfmSave(){
            let arr =[]
            this.refData.forEach(item=>{
                if (item['SEL']=='Y'){
                    let obj ={}
                    let v_pkseq =item['IDSEQ']+'-'+item['LSTSEQ']
                    Object.assign(obj,{SKUNO:item['SKUNO'],REFTYNM:item['REFTYNM'],REFIDNO:item['IDNO'],REFDTTM:item['ORDDTTM'],MATNO:item['MATNO'],MATNM:item['MATNM'],MATDESC:item['MATDESC'],QTY:item['QTY'],PRC:item['PRC'],BOXCUBE:item['BOXCUBE'],REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']})
                    let bool =true
                    //判断是否存在添加 
                    this.listData.some(item=>{
                        if (item['REFIDSEQ']+'-'+item['REFLSTSEQ'] ==v_pkseq){
                            bool =false
                        }
                    })
                    if (bool){
                        arr.push(obj)
                    }
                }
            })
      
            if (arr.length >0){
                arr.forEach(item=>{
                    this.listData.push(item)
                }) 
            }
            this.refWin=false
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.listref.doLayout();
            })
        },
        chkSel(){
            if(this.v_all =='Y'){
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.bankData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }

        },
        //
        selectChg(key){
            if (key =='HAPPEN'){
                
                if (this.formCol['HAPPEN']=='407503'){
                    this.hapBool =true
                }else{
                    this.hapBool =false
                }
                if (this.formCol['FINVNO']){
                    this.formCol['FINVNO']=''
                }
            }
        },
        selChg(){
            if(this.selAll =='Y'){
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'Y'})
                })
            }else{
                this.refData.forEach(item=>{
                    Object.assign(item ,{SEL:'N'})
                })
            }
        },
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='CHKAMT'||column.property==='ACTPAY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getDtlSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
 
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='CHKAMT'||column.property==='ACTPAY'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        getListSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='DISAMT'||column.property==='AMT'|| column.property==='QTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        deptChg(val){
            this.deptArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DEPTNM:item['CNAME']})
                }
            })
        },
        disChg(val){
            this.disArr.some(item=>{
                if (item['CODE']==val){
                    Object.assign(this.dtlCol,{DISTYNM:item['CNAME']})
                }
            })
        },
 
        empChg(val){
            this.formCol['DEPTNO']=''
            this.formCol['BANKADDR']=''
            this.formCol['BANKNO']=''
            this.formCol['BANKNM']=''
            this.formCol['RCVER']=''
            this.formCol['DAYS']=0
            this.empArr.some(item=>{
                if(item['EMPNM']==val){
                    this.formCol['DEPTNO']=item['DEPTNM']
                    this.formCol['BANKADDR']= this.formCol['ISTAX']=='Y'?item['BANKADDR']:item['BANKADDR2']
                    this.formCol['BANKNO']=this.formCol['ISTAX']=='Y'?item['BANKNO']:item['BANKNO2']
                    this.formCol['BANKNM']=this.formCol['ISTAX']=='Y'?item['BANKNM']:item['BANKNM2']
                    this.formCol['RCVER']=this.formCol['ISTAX']=='Y'?item['EMPNM']:item['EMPNM2']
                    this.formCol['DAYS']=item['DAYS']
                }
            })
        },
        disFee(){
            this.disWin =true
        },
        //下一步
        nextStep(){
            let selArr =[]
            this.bankData.forEach(item=>{
                let obj={}
                if (item['SEL']=='Y'){
                    Object.assign(obj,item,{IDSEQ:'',LSTSEQ:'',REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ']  })
                    selArr.push(obj)
                }
            })
            if (selArr.length>0){
                this.stepFlag =false
                this.$nextTick(()=>{
                    console.log(this.v_data[0]['EMPNO'],'...print')
                    this.$refs['refbank']['v_word']='4260'
                    this.$refs['refbank']['v_orgnm']=this.v_data[0]['EMPNO'] //this.formCol['EMPNO']
                    this.$refs['refbank']['spFlag'] =false
                    this.$refs['refbank'].addRec()
                    this.$refs['refbank'].feeData =selArr
                })
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1783', '请选择需要记账的记录')
            }
        },
        //分摊费用
        feeSave(){
            if (!this.feeMth ){
                this.promptWin =true
                this.prompt =this.$LANG('1727', '请选择分摊方式')
            }else{
                let amt =0 ,v_mth =''
                //获取 方式中文名称
                this.feeArr.some(item=>{
                    if (item['CODE']==this.feeMth){
                        v_mth =item['CNAME']
                    }
                })
                this.dtlData.forEach(item=>{
                    if (item['ISOK']=='Y'){
                        amt =Number(amt)+Number(item['CHKAMT'])
                    }
                })           
                if(amt>0){
                    //默认按金额比例分摊 费用
                    let sum =0  //总金额
                    if (this.feeMth=='230800') { //按价格
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['PRC'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['PRC'])>0 ){
                                    let v_disamt =Number(amt *Number(item['PRC']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else if (this.feeMth=='230801') { //按体积
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['BOXCUBE']*item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['BOXCUBE'])>0 ){
                                    let v_disamt =Number(amt *Number(item['BOXCUBE']*item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT: v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }else{  //按数量
                        this.listData.forEach(item=>{
                            sum=Number(sum)+Number(item['QTY'])
                        })
                        if (sum >0){
                            this.listData.forEach((item,index)=>{
                                if (Number(item['QTY'])>0 ){
                                    let v_disamt =Number(amt *Number(item['QTY']/Number(sum))).toFixed(2)
                                    let v_amt = (v_disamt/Number(item['QTY'])).toFixed(2)
                                    this.listData.splice(index,1,  Object.assign(item ,{DISMTH:v_mth,DISAMT:v_disamt,AMT:v_amt}) )
                                }
                            })
                        }
                    }
                    this.disWin=false
                }else{
                    this.disWin=false
                    this.promptWin =true
                    this.prompt =this.$LANG('1818', '没有费用需分摊，请核查')
                }
            }
        },
        //关联单据
        addList(){
            if (this.billType){ 
                this.tyArr.some(item=>{
                    if (item['CODE']== this.billType){
                        this.v_view =item['SUBNO']
                        this.v_type =item['CNAME']
                    }
                })
                if (this.v_view){
                    this.v_loading =true
                    this.refWin =true
                    this.refData=[]
                    getTabColOrData(this.v_url,this.v_view,'corpid',this.v_corpid,'','','','','').then((res) => {
                        this.refData =res.result
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs.refjoin.doLayout()
                            this.v_loading =false
                        })
                    })
                }else{
                    this.promptWin =true
                    this.prompt =this.$LANG('1863', '此单据类型的数据源还未设置')
                }
            }else{
                this.promptWin =true
                this.prompt =this.$LANG('1728', '请选择单据类型')
            }
        },
        qryRefData(){
            let cond_=''
            if (this.selparam3 && this.textparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and  '+this.selparam3+'  like  \'%' + this.textparam3+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam3 +this.oper3+' \''+this.textparam3+'\' '
                }
            }
            this.v_loading =true
            getTabColOrData(this.v_url,this.v_view,'CORPID',this.v_corpid,'','','','',cond_).then((res) => {
                this.refData =res.result
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refjoin.doLayout()
                    this.v_loading =false
                })
            })
        },
        //新增费用
        addDtl(){
            this.dtlFlag='create'
            this.dtlCol={ISOK:'Y',CRCY:'人民币'}
            this.dtlWin =true
        },
        dtlEdit(row ,index){
            this.dtlCol=JSON.parse(JSON.stringify(row))
            this.dtlWin=true
            this.dtlFlag='edit'
            this.rowIndex=index
        } ,
        dtlSave(){
            this.notDtl.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.dtlCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool) {
                this.dtlWin =false
                if (this.dtlFlag==='edit' ){ //编辑时要替换数组记录
                    this.dtlData.splice(this.rowIndex,1,this.dtlCol)
                }else{
                    this.dtlData.push(this.dtlCol)
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.dtlref.doLayout();
            })
        },
        dtlDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
 
                this.dtlData.splice( index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delArr.push(row)
                }
            }).catch(()=>{})
        },
        listDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.listData.splice(index,1)
                if (row['IDSEQ'] && row['LSTSEQ']){
                    this.delData.push(row)
                }
            }).catch(()=>{})
        },
        tabDel(row,index){
            this.$confirm(this.$LANG('1594', '你确定要删除此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //先删除分摊表
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_feelist'},
                }).then(res=>{    
                    //再删除明细表  
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_feedtl'},
                    }).then(res=>{
                        //最后删除主表
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'fin_fee'},
                        }).then(res=>{
                            this.tabData.splice(index,1)
                        })
                    })      
                }) 
            }).catch(()=>{})
        },
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'227450',p_cond:' and lstseq in (1,2,3)' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //表行点击事件
        rowClick(row){
            this.v_idseq =row['IDSEQ']
            
            if (row['STFG']==='Y')  {  
                this.stfgColor='color:green'
                this.stfgCss='icon-yishenhe1'
            }else if (row['STFG']==='X')  {  
                this.stfgColor='color:red'
                this.stfgCss='icon-yizuofei'
            }else{
                this.stfgColor='color:gray'
                this.stfgCss='icon-weishenhe3'
            }
        },
        //查询明细数据
        getDtlData(idseq){
            this.dtlData=[]
            getTabColOrData(this.v_url,'V_FIN_FEEDTL','idseq',idseq).then((res) => {
                this.dtlData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.dtlref.doLayout()
                })
            })
        },
        getItmData(idseq){
            this.listData=[]
            getTabColOrData(this.v_url,'V_FIN_FEElist','idseq',idseq).then((res) => {
                this.listData =res.result  
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.listref.doLayout();
                })
            })
        },
        //查询
        getTabList(){
            let cond_ = this.oper === '!=' && this.selparam && !this.txtparam
                ? ' and '+this.selparam+' is null '
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
 
            if (this.notAcc=='N'){
                cond_=cond_+ ' and idseq in (select idseq from V_Fee_book where stfg=\'Y\' and payidno is null)'
            }else if (this.notAcc=='Y'){
                cond_=cond_+ ' and idseq in (select idseq from V_Fee_book where stfg=\'Y\' and payidno is not null)'
            }else if (this.notAcc=='C'){
                cond_=cond_+ ' and idseq not in (select idseq from V_Fee_book where stfg=\'Y\' and payidno is not null)'
            }
            cond_ += buildVeTableHeaderCondition(this.initCol, this.v_row, { typeOverrides: { STFG: 'select' } })
            this.current = 1
            this.getFeeList(cond_)
        },
        editRec(row,val){
            if (row['STFG']=='Y'||val=='Y'){
                this.saveFlag=true
            }else{
                this.saveFlag=false
            }
            this.v_stfg =row['STFG']
            this.addWin =true
            this.formCol =JSON.parse(JSON.stringify(row))
            this.getDtlData(row['IDSEQ']) 
            this.getItmData(row['IDSEQ'])
            this.delArr =[]
 
            this.v_commit =true
            this.v_selAll='N'
            if (row['HAPPEN']=='407503'){
                this.hapBool =true
            }else{
                this.hapBool =false
            }
        },
        //修改发票
        editInv(row){
            this.invWin =true
            this.v_invno =row['FINVNO']
            this.v_invRow =JSON.parse(JSON.stringify(row))
        },
        invSave(){
            let v_invno =''
            if (this.v_invno){
                v_invno =this.v_invno
            }
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'idseq',p_value:this.v_invRow['IDSEQ'],p_table:'FIN_FEE',p_cond: ' set finvno=\''+v_invno+'\''},
            }).then(res=>{  
                this.getTabList()
                this.invWin =false
            })
        },
        cfmSet(val){
            this.$confirm(this.$LANG('1564', '你确定要')+(val=='Y'?this.$LANG('0134', '审核'):this.$LANG('0137', '弃审'))+this.$LANG('1574', '此记录吗'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                var vm=this,cond_=''
                if (val==='Y'){
                    this.saveFlag=true
                    cond_=' set stfg=\'Y\' ,chkdttm=\''+getDate('full')+'\' ,chkuser=\''+this.v_username+'\''
                }else{
                    this.saveFlag=false
                    cond_=' set stfg=\'N\' , chkdttm=null  , chkuser=null'
                }
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.formCol['IDSEQ'],p_table:'FIN_FEE',p_cond: cond_},
                }).then(res=>{              
                    this.getTabList() 
                    this.addWin=false          
                }) 
            }).catch(()=>{})          
 
        },
        //状态审核
        recSet(row, val,text){
            this.d_stfg=true
            let v_ok =false ,v_cancel=false
            if( text=='弃审'){
                if (this.v_usernm !==row['CHKUSER']){
                    v_ok =true
                }
            }
            if( text=='弃认'){
                if (this.v_usernm !==row['APPUSER']){
                    v_cancel =true
                }
            }
            if (v_ok){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1049', ' 与审核用户：')+row['CHKUSER']+this.$LANG('1646', ' 不同时不能弃审')
            }else if (v_cancel){
                this.promptWin =true
                this.prompt =this.$LANG('0028', '当前用户:')+this.v_usernm+this.$LANG('1050', ' 与确认用户：')+row['APPUSER']+this.$LANG('1647', ' 不同时不能弃认')
            }else if (!row['PAYDTTM']){
                this.promptWin =true
                this.prompt =this.$LANG('1807', '付款期限为空时不能确认')
            }else{
                this.$confirm(this.$LANG('1564', '你确定要')+text+this.$LANG('1574', '此记录吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{ 
                    let v_bool =true
                    if (val=='K' && row['HAPPEN']=='407503'){
                        if (!row['STKNO']){
                            v_bool =false
                            this.promptWin =true
                            this.prompt =this.$LANG('1976', '已审核')+this.$LANG('1943', '的')+this.$LANG('1838', '入库单')+this.$LANG('2051', '不能为空')
                        }else if (!row['FINVNO']){
                            v_bool =false
                            this.promptWin =true
                            this.prompt =this.$LANG('0452', '对账单')+this.$LANG('1943', '的')+this.$LANG('0635', '发票号码')+this.$LANG('2051', '不能为空')
                        }
                    }else if (val=='K' && row['ISTAX']=='Y'){ //含税 需要发票
                        if (!row['FINVNO'] && row['DISTY']!=='228808'){ //分摊类型不是 OKR 需用预算及管控
                            v_bool =false
                            this.promptWin =true
                            this.prompt =this.$LANG('0452', '对账单')+this.$LANG('1943', '的')+this.$LANG('0635', '发票号码')+this.$LANG('2051', '不能为空')
                        }
                    }
                    if (v_bool) {
                        let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
                        if (val =='K') {
                            if(text=='弃审'){
                                v_cfmdttm =''
                                v_cfmuser =''
                            }else{
                                v_cfmdttm =getDate('full')
                                v_cfmuser =this.v_usernm
                            }
                            v_cond =' set stfg=\''+val+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\',chkuser=null,chkdttm=null'
                        }else if (val =='Y'){
                            v_chkdttm =getDate('full')
                            v_chkuser =this.v_usernm
                            v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
                        }else{
                            v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                            v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',appuser=\''+v_cfmuser+'\',appdttm=\''+v_cfmdttm+'\''
                        }
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'FIN_FEE',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  {           
                                if (val =='Y'){
                                    Object.assign(row,{STFGNM:text ,STFG:val, APPUSER:v_cfmuser,APPDTTM:v_cfmdttm})
                                }else{
                                    Object.assign(row,{STFGNM:text ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm,APPUSER:v_cfmuser,APPDTTM:v_cfmdttm,ISCHK:val=='K'?'Y':'N'})
                                } 
                            }else{
                                this.promptWin=true
                                this.prompt=res.result
                            }        
                        }) 
                        //发起审批时
                        if (val =='K'){
                            // 调用工作流启动函数
                            startWorkflowInstance({
                                flowId: '227450',
                                businessId: row.IDSEQ, // 使用文件ID作为业务单据ID
                                actualInitiator: {empnm:this.v_usernm,empno:this.v_username,corpid:this.v_corpid},
                                component: this,
                                axios: this.$axios,
                                baseUrl: '',
                                // 微信消息相关参数
                                docType: '报销-管理摊分', // 单据类型
                                DIRNM: row.EMPNM, // 项目名称，使用文件名
                                CNAME: row.REASON,
                                businessData: {
                                    flowType: 3,
                                    qty: null,
                                    amt: row['TTLAMT'],
                                },
                                jumpUrl: window.location.href // 跳转URL，使用当前页面地址
                            })
                            this.d_stfg=false
                        }else if( text=='弃认'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'P\''},
                            }).then(res=>{
                                // 在日志表中 插入 一条 弃认记录
                                let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:this.$LANG('1212', '发起人 弃认')}
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                }).then(res=>{  
                                    this.d_stfg=false 
                                })
                            })
                        }else if( text=='弃审'){ // 要把  SYS_FLOW_APPUSER 的状态为P 改为N
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'IDSEQ',p_value:row['IDSEQ'],p_table:'SYS_FLOW_APPUSER',p_cond:' set stfg=\'N\'',p_where:' and stfg=\'Y\' and iscc=0'},
                            }).then(res=>{
                                // 在日志表中 插入 一条 弃认记录
                                let v_obj={IDSEQ:row['IDSEQ'],LSTSEQ:'',EMPNO:this.v_username,EMPNM:this.v_usernm,APPDTTM:getDate('full'),STFG:'N',LOGTY:'R',RMK:this.$LANG('1211', '发起人 弃审')}
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(v_obj), p_table:'SYS_FLOW_APPLOG' },
                                }).then(res=>{   
                                    this.d_stfg=false
                                })
                            })
                        }else{
                            this.d_stfg=false
                        }
                    }
                }).catch(()=>{})
            
            }
        },
        //fee 明细
        getFeeList(cond){
            const requestId = ++this.queryRequestId
            //获取所有产品记录且初始化分页记录  433336  
            this.loadingInstance.show()    
        
            let v_cond =   buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            console.log(v_cond,'...')    
            if (this.othBool==true){
                v_cond=' and adduser=\''+this.v_usernm+'\' '
            }  
 
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+v_cond+' and paysrc!=\'433336\' order by '+this.selparam +' desc' ,p_table:'V_FIN_FEE'},
            }).then(res=>{ 
                if (requestId !== this.queryRequestId) return
                if (res.code==='200'){
                    this.allList =res.result
                    this.initPage()
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.loadingInstance.close() 
                })
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.promptWin=true
                this.prompt=error && error.message ? error.message : this.$LANG('1641', '查询失败')
                this.loadingInstance.close()
            }) 
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ']
        },
        getListKey(row){
            return row.REFIDSEQ+'-'+row['REFLSTSEQ'] 
        },
        getRefKey(row){
            return row.IDSEQ+'-'+row['LSTSEQ'] 
        },
        //新增 
        addRec(){
            this.addWin=true
            this.addFlag='create'
            this.saveFlag=false
            this.formCol={DTTM:getDate(),STFG:'N',ISTAX:'Y'}
            this.dtlData=[]
            this.listData=[]
            this.v_commit =true
        },
        //保存记录
        saveRec(){
            var vm =this 
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.formCol[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=this.$translate.getColTitle(item, this.$store.state.lang)+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool && this.v_commit) {    
                let obj_ ={}    
                Object.assign(obj_,this.formCol,{ 'CORPID':this.v_corpid,STFG:'N'}) 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'FIN_FEE',frmid:'227450'},
                }).then(res=>{      
                    if(res.result ==='OK')  {
                        this.v_commit =false
                        let v_idseq =res.idseq
                        //报销明细保存：批量保存  res.idseq
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'FIN_FEEdtl',p_idseq:v_idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                         //明细删除
                         if (this.delArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delArr), p_table:'FIN_FEEdtl',p_idseq:v_idseq,p_action:'D' },
                            })
                         }   
                        //费用摊分保存：批量保存 
                         this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.listData), p_table:'FIN_FEELIST',p_idseq:v_idseq,p_action:'S' },
                         }).then(res=>{
                             if (res.code!=='200'){
                                 this.promptWin=true
                                 this.prompt=res.result
                             }
                         })
                        //  费用删除
                        if (this.delData.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delData), p_table:'FIN_FEElist',p_idseq:v_idseq,p_action:'D' },
                            })
                        } 
                 
                        vm.addWin =false   
                        vm.chkChg(this.notAcc)
                    }else{
                        this.v_commit =true
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
 
        },
        //获取表列字段
        getTabField(){
            let vm =this
            this.tabArr =[]
            this.vueCol =[]
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                this.initCol =res.result
                return this.loadInitialFieldSettings().then(() => res)
            }).then(() => {
                const mainFields =this.sortFieldRows(this.initCol)
                for (let k=0; k<mainFields.length; k++){
                    let itcol =mainFields[k]
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                        key: itcol.key,
                        align: itcol.align,
                        width: itcol.width,
                        edcss:itcol.EDCSS,
                        thide:itcol.THIDE,
                        fhide:itcol.FHIDE,
                        disabled:itcol.DISABLED,
                        sortable:itcol.SORTABLE,
                    })
                    if (itcol['THIDE']=='N'){
                        let v_obj ={   //向数组的开头 添加序列号
                            field:itcol['key'] ,
                            title: vm.$translate.getColTitle(itcol, vm.$store.state.lang),
                            key: itcol['key']  ,
                            type:itcol.EDCSS=='checkbox'?'check':itcol.EDCSS,
                            align: itcol.align,                                
                            width: Number(itcol.width),
                            thide:itcol.THIDE,
                            fhide:itcol.FHIDE,
                            sortable:false,
                            renderHeaderCell: ({column}) => <VeTableQueryHeader title={column.title} edcss={itcol.key === 'SEL' ? 'image' : itcol.key === 'STFG' ? 'select' : itcol.EDCSS} value={this.v_row[column.key]} operator={this.v_row[`#OPER${column.key}`]} options={itcol.key === 'STFG' ? [{ value: 'Y', label: this.$LANG('1976', '已审核') }, { value: 'P', label: this.$LANG('1961', '审核中') }, { value: 'K', label: this.$LANG('1982', '已确认') }, { value: 'N', label: this.$LANG('2005', '未审核') }] : []} on-input={(value) => this.$set(this.v_row, column.key, value)} on-operator-change={(value) => this.$set(this.v_row, `#OPER${column.key}`, value)} on-title-click={() => this.sortChange(column)} on-query={this.getTabList} />,
                            disabled:itcol.DISABLED,
                            ellipsis: { showTitle: true, },
                            renderBodyCell: ({row,column,rowIndex},h) => {
                                let  rowVal =row[itcol['key'] ]
                                if (itcol.key=='SEL' ){
                                    return ( 
                                        <el-checkbox true-label="Y" disabled={row['STFG']!=='Y'} false-label="N" v-model={row['SEL']}  style="width:100%;"   > </el-checkbox>
                                    )
                                } else if (column.key=='STFG') {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('1976', '已审核')}</el-tag> )
                                    }else if (row[itcol['key']] =='P'){
                                        return (<el-tag   size="mini" type="warning" effect="dark">{this.$LANG('1961', '审核中')}</el-tag> )
                                    }else if (row[itcol['key']] =='K'){
                                        return (<el-tag   size="mini" type="danger" effect="dark">{this.$LANG('1982', '已确认')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2005', '未审核')}</el-tag> )
                                    }                                          
                                }else if (column.key=='IDNO') { //单据
                                    return (
                                        <el-link   on-click={()=>{this.repBtn(row)}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (column.key=='PONO') { //采购单
                                    return (
                                        <el-link   on-click={()=>{this.repPreview(row['PONO'],'po')}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (column.key=='STKNO') { //入库单
                                    return (
                                        <el-link   on-click={()=>{this.repPreview(row['STKNO'],'stk')}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (column.key=='FINVNO') { //入库单
                                    return (
                                        <el-link   on-click={()=>{this.imgPreview(row['INVPATH'] )}}  underline={false} ><span style="font-size:13px;border-bottom:1px solid #409eff;font-weight:700">{row[itcol['key']]}</span></el-link> 
                                    )
                                }else if (itcol.EDCSS=='checkbox' ) {                         
                                    if (row[itcol['key']] =='Y'){
                                        return (<el-tag   size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> )
                                    }else {
                                        return (<el-tag   size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> )
                                    }                                          
                                }else{
                                    return row[itcol['key'] ]
                                }
                            },                                
                        }
                        this.vueCol.push(v_obj)
                    }
                }
                // 分组 字段
                let v_rownum ={
                    field: "index",
                    key: "rownum",
                    title: this.$LANG('0310', '序号'),
                    width: 55,
                    align: "left",
                    fixed:"left",
                    disableResizing: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['ISOVER']=='Y'){
                            return (<span style="color:#1890ff;">
                                {rowIndex + this.startRowIndex + 1}
                                <span  style=" font-size:12px;width:20px;height:20px;background:#f00;color:white;margin-left:4px ">{this.$LANG('1658', '超')}</span>
                            </span> )
                        }else{
                            return (<span style="color:#1890ff;">
                                {rowIndex + this.startRowIndex + 1}
                            </span> )
                        }
                    },
                    renderHeaderCell: ({column}, h) => {
                        return (  
                            <div >
                                <div style="margin-top:3px">{column.title}</div>
                                <el-link on-click={()=>{this.rowShow()}} style="font-size:12px;color:#404eff;height:30px"> 
                                    <el-tooltip content={this.$LANG('0852', '清除条件')} effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </div>
                        )
                    },
                }
                let v_oper ={
                    field: "oper0",
                    key: "oper",
                    title: this.$LANG('0330', '操作'),
                    width: 230,
                    align: "center",
                    fixed:"right",
                    disableResizing: true,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row['STFG']=='N') {
                            return ( 
                                <div>    
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editRec(row,'N' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('1639', '编辑')}</span></el-link>
                                    <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cancelBool||this.d_stfg} on-click={()=>{this.recSet(row,'K', '确认')}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0364', '确认')}</span></el-link>
                                    <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.delBool} on-click={()=>{this.tabDel(row, rowIndex)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0131', '删除')}</span></el-link>
                                </div>                                
                            )  
                        }else if (row['STFG'] =='Y') {
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:10px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cfmBool} on-click={()=>{this.recSet(row,'N', '弃审')}}  underline={false} ><span style="font-size:12px;margin-right:10px;">{this.$LANG('0137', '弃审')}</span></el-link>
                                    <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.editBool} on-click={()=>{this.editInv(row)}}  underline={false} ><span style="font-size:12px; ">{this.$LANG('0582', '修改发票')}</span></el-link>
                                </div>                                
                            )  
                        }else if (row['STFG'] =='P') {
                            return ( 
                                <div>
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>

                                </div>                                
                            )  
                        }else if (row['STFG'] =='K') {
                            return ( 
                                <div>
 
                                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link   on-click={()=>{this.editRec(row,'Y' )}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0139', '查看')}</span></el-link>
                                    <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                    <el-link  disabled={this.cancelBool} on-click={()=>{this.recSet(row,'N', '弃认')}}  underline={false} ><span style="font-size:12px;margin-right:5px;">{this.$LANG('0314', '弃认')}</span></el-link>
 
                                 
                                </div>                                
                            )  
                        }
                    },
                }
                this.vueCol.unshift(v_rownum) 
                this.vueCol.push(v_oper)
                this.applyFieldSettingRows()
            })
            //<i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
            //<el-link   on-click={()=>{this.showApp(row)}}  underline={false} ><span style="font-size:12px;margin-right:5px;">查看审批</span></el-link>
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.listArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','227450','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.refArr.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','123','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.saleCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
        height:50px;
    }
    .active { 
        color:#D200D2; 
    } 
    .consume-mgt-toolbar {
        align-items: center;
        flex-wrap: nowrap;
    }
    .consume-mgt-toolbar__action {
        display: inline-flex;
        align-items: center;
        flex: 0 0 auto;
        white-space: nowrap;
    }
    .consume-mgt-toolbar__field-icon {
        flex: 0 0 auto;
        line-height: 1;
    }
 
</style>
<style lang="less">
    .el-table .red-row  {
        color: red;
    }
 
    .table-foot-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #b2d3fa !important;
        font-weight:700 !important;
        padding: 2px !important;
        line-height: 25px !important;
        text-align:left !important;
        height: 15px !important;
   
    }
    .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        padding:0px !important;
        padding-top:4px !important;
        text-align:center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    .table-head-cell-class2 {
        font-size: 12px !important;
        color: rgb(134, 4, 4) !important;
        background: #e2e6eb !important;
        font-weight:700 !important;
        border-width: 1px !important;
        border-color: #808695 !important;
        padding:6px !important;
    }
    .table-body-cell-class1 {
        font-size: 12px !important;
        color: black !important;
        border-width: 1px !important;
        padding:2px !important;
        border-color: #808695 !important;
    }
    .el-table .bold-row  {
        color: #9e0404;
        font-weight:600;
        font-size:12px;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table__body {
        width: 100%;
        // 使表格兼容safari，不错位
        table-layout: fixed !important;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 3px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
